module.exports = __webpack_public_path__ + "img/image.ba15c026.png";